export default function loadMapData(name) {
    return new Promise((resolve, reject) => {
        switch (name) {
            case "BeiJingCounty":
                require(['./../common/inMapOverlay/BeiJingCounty-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;
            case "BeiJingScenic":
                require(['./../common/inMapOverlay/BeiJingScenic-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;

            case "ChangJiangCitys":
                require(['./../common/inMapOverlay/ChangJiangCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "ChangJiangCounty":
                require(['./../common/inMapOverlay/ChangJiangCounty-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "ChengDuCounty":
                require(['./../common/inMapOverlay/ChengDuCounty-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "ChinaProvince":
                require(['./../common/inMapOverlay/ChinaProvince-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "CityProvince":
                require(['./../common/inMapOverlay/CityProvince-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;

            case "DaWanQuCitys":
                require(['./../common/inMapOverlay/DaWanQuCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "HeBeiCitys":
                require(['./../common/inMapOverlay/HeBeiCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "JiangSuCitys":
                require(['./../common/inMapOverlay/JiangSuCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;


            case "jingjinjiCitys":
                require(['./../common/inMapOverlay/jingjinjiCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;

            case "jingjinjiCounty":
                require(['./../common/inMapOverlay/jingjinjiCounty-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;

            case "TianJinCounty":
                require(['./../common/inMapOverlay/TianJinCounty-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;

            case "ZheJiangCitys":
                require(['./../common/inMapOverlay/ZheJiangCitys-Polygon/data.json'], (data) => {
                    resolve(data);
                });
                break;
        }

    });

}